import styled from 'styled-components';

export const Container = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const Header = styled.div`
  margin-bottom: 2rem;
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #007BC6;
  margin-bottom: 0.5rem;
`;

export const Subtitle = styled.p`
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  
  p {
    margin-top: 1rem;
    color: #6c757d;
    font-size: 1.1rem;
  }
`;

export const PagamentosContainer = styled.div`
  width: 100%;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  color: #6c757d;
  
  h4 {
    margin: 1rem 0 0.5rem 0;
    color: #495057;
  }
  
  p {
    margin: 0;
    font-size: 1.1rem;
  }
`;

export const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

export const PagamentosList = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PagamentoCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }
`;

export const CardHeader = styled.div`
  background: #007BC6;
  color: white;
  padding: 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PlanoInfo = styled.div`
  flex: 1;
`;

export const PlanoNome = styled.h5`
  margin: 0 0 0.25rem 0;
  font-weight: 600;
  font-size: 1.2rem;
`;

export const PagamentoId = styled.p`
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
`;

export const CardBody = styled.div`
  padding: 1.25rem;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: #495057;
  font-size: 0.95rem;
`;

export const InfoValue = styled.span`
  color: #6c757d;
  font-size: 0.95rem;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
`;

export const CardFooter = styled.div`
  padding: 1rem 1.25rem;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
`;

export const ReembolsoInfo = styled.div`
  color: #6c757d;
  font-size: 0.9rem;
  text-align: center;
  font-style: italic;
`;

// Estilos para o Badge customizado
export const StatusBadge = styled.div`
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  
  &.success {
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
  }
  
  &.warning {
    background: linear-gradient(135deg, #ffc107, #fd7e14);
    color: #212529;
  }
  
  &.secondary {
    background: linear-gradient(135deg, #6c757d, #495057);
    color: white;
  }
`;

// Responsividade aplicada diretamente nos componentes
export const ResponsiveContainer = styled(Container)`
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const ResponsiveTitle = styled(Title)`
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const ResponsiveCardHeader = styled(CardHeader)`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

export const ResponsiveInfoRow = styled(InfoRow)`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
`;

export const ResponsiveInfoValue = styled(InfoValue)`
  @media (max-width: 768px) {
    max-width: 100%;
    text-align: left;
  }
`;